import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-article-card/common-article-card.ts
var CommonArticleCard = class extends SnippetElement {
  connectedCallback() {
    this.calculateReadingTime(this.readingTime.getAttribute("data-reading-time"));
  }
  calculateReadingTime(characterCount) {
    var charactersPerMinute = 1e3;
    var readingTime = Math.ceil(characterCount / charactersPerMinute);
    this.readingTime.innerHTML = readingTime + " Min.";
  }
};
__decorateClass([
  query("[data-reading-time]")
], CommonArticleCard.prototype, "readingTime", 2);
CommonArticleCard = __decorateClass([
  defineElement("common-article-card")
], CommonArticleCard);
export {
  CommonArticleCard
};
